const inkImageCrop = {
  bindings: {
    modalInstance: '<',
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: 'ImageCropModalController',
  template: require('./image-crop-modal.template.html')
};

angular
  .module('inkfinder')
  .component('inkImageCrop', inkImageCrop);



// WEBPACK FOOTER //
// ./components/image/crop-modal/image-crop-modal.component.js